// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.filters {
  grid-template-columns: repeat(5, auto);
}
.grid.person-history {
  grid-template-columns: repeat(5, auto);
}
.grid.notes {
  grid-template-columns: repeat(4, auto);
}
.grid.notes-add {
  grid-template-columns: repeat(6, auto);
}
.grid.decision-management {
  grid-template-columns: repeat(5, auto);
}
.grid.invite {
  grid-template-columns: repeat(9, auto);
}
.grid.criminal-history {
  grid-template-columns: repeat(13, auto);
}
.grid.address-history {
  grid-template-columns: repeat(10, auto);
}
.grid.reference-questions {
  grid-template-columns: repeat(2, auto);
}
.grid.eviction-history {
  grid-template-columns: repeat(14, auto);
}
.grid.ssn-history {
  grid-template-columns: repeat(7, auto);
}
.grid.tax-lien-history {
  grid-template-columns: repeat(15, auto);
}
.grid.bankruptcy-history {
  grid-template-columns: repeat(4, auto);
}
.grid.searches {
  grid-template-columns: repeat(9, auto);
}
.grid.income-verification-grid {
  grid-template-columns: repeat(4, auto);
}
.grid.custom-search-history {
  grid-template-columns: repeat(6, auto);
  white-space: pre-wrap;
}
.grid.verification {
  padding: 15px 0;
  grid-template-columns: repeat(6, auto);
}
.employer-long {
  grid-column: 2 / span 3;
}
.grid.reference-verification-history {
  grid-template-columns: repeat(7, auto);
  white-space: pre-wrap;
}
.table-data.left {
  text-align: left;
}
.table-data-rec-dec {
  grid-column-start: 1;
  grid-column-end: 6;
}
.super-strong {
  font-size: 20pt;
  font-weight: bolder;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.wrapit {
  overflow-x: scroll;
}
.error-state {
  background: #ce6161 !important;
}
.canceled-state {
  background: #d88949 !important;
}
.voided-state {
  background: #e2b94f !important;
}
.invoiced-state {
  background: #A5DC89 !important;
}
.paid-state {
  background: #6699CC !important;
}
h2.filter-title {
  border-bottom: 1px solid #d8d9ea;
  clear: both;
}
.change-property-decision-warn {
  background-color: white;
  border: 1px solid;
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 55;
}
div.modal-overlay-decision-warn {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 50;
}
.decline-reason-control {
  width: 100%;
}
.fa-trash,
.fa-recycle {
  color: #5484ff;
  cursor: pointer;
  margin: 1px;
  display: inline;
}
#scrnNoteDisplay {
  border: none !important;
}
.open-issue {
  background-color: #ce6161 !important;
  color: white !important;
}
.tnt-view {
  background-color: #b10000 !important;
  color: white !important;
}
.ffd {
  background-color: #7600b1 !important;
  color: white !important;
}
.dispute-button {
  background-color: #d88949 !important;
}
.release-report {
  background-color: #54a54e !important;
  color: white !important;
}
.disclose-report {
  background-color: #0820a3 !important;
  color: white !important;
}
.table-header-crim {
  font-weight: 600 !important;
  padding: 7px 5px;
  color: #4b58a6;
}
.table-data-crim {
  border-top: 1px solid #e7ebeb;
  padding: 3px;
  align-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  background: white;
}
.criminal-history {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/screening-view/screening-view.component.less"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,uCAAA;AACJ;AACA;EACI,uCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,uCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,uCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;AACJ;AACA;EACI,sCAAA;EACA,qBAAA;AACJ;AACA;EACE,eAAA;EACA,sCAAA;AACF;AACA;EACE,uBAAA;AACF;AAEA;EACI,sCAAA;EACA,qBAAA;AAAJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,oBAAA;EACA,kBAAA;AAFJ;AAIA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAFJ;AAKA;EACI,kBAAA;AAHJ;AAMA;EACI,8BAAA;AAJJ;AAOA;EACI,8BAAA;AALJ;AAQA;EACI,8BAAA;AANJ;AASA;EACI,8BAAA;AAPJ;AAUA;EACI,8BAAA;AARJ;AAWA;EACI,gCAAA;EACA,WAAA;AATJ;AAYA;EACI,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AAVJ;AAaA;EACI,oCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAXJ;AAcA;EACI,WAAA;AAZJ;AAeA;;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAZJ;AAeA;EACI,uBAAA;AAbJ;AAiBA;EACI,oCAAA;EACA,uBAAA;AAfJ;AAkBA;EACI,oCAAA;EACA,uBAAA;AAhBJ;AAkBA;EACI,oCAAA;EACA,uBAAA;AAhBJ;AAmBA;EACI,oCAAA;AAjBJ;AAoBA;EACI,oCAAA;EACA,uBAAA;AAlBJ;AAqBA;EACI,oCAAA;EACA,uBAAA;AAnBJ;AAqBA;EACI,2BAAA;EACA,gBAAA;EACA,cAAA;AAnBJ;AAuBA;EACI,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArBJ;AAyBA;EAGI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAzBJ","sourcesContent":["h1 {\n    margin: 0;\n}\n.grid.filters {\n    grid-template-columns: repeat(5, auto);\n}\n.grid.person-history {\n    grid-template-columns: repeat(5, auto);\n}\n.grid.notes {\n    grid-template-columns: repeat(4, auto);\n}\n.grid.notes-add {\n    grid-template-columns: repeat(6, auto);\n}\n.grid.decision-management{\n    grid-template-columns: repeat(5, auto);\n}\n.grid.invite {\n    grid-template-columns: repeat(9, auto);\n}\n.grid.criminal-history{\n    grid-template-columns: repeat(13, auto);\n}\n.grid.address-history{\n    grid-template-columns: repeat(10, auto);\n}\n.grid.reference-questions{\n    grid-template-columns: repeat(2, auto);\n}\n.grid.eviction-history{\n    grid-template-columns: repeat(14, auto);\n}\n.grid.ssn-history {\n    grid-template-columns: repeat(7, auto);\n}\n.grid.tax-lien-history {\n    grid-template-columns: repeat(15, auto);\n}\n.grid.bankruptcy-history {\n    grid-template-columns: repeat(4, auto);\n}\n.grid.searches {\n    grid-template-columns: repeat(9, auto);\n}\n.grid.income-verification-grid {\n    grid-template-columns: repeat(4, auto);\n}\n.grid.custom-search-history {\n    grid-template-columns: repeat(6, auto);\n    white-space: pre-wrap;\n}\n.grid.verification {\n  padding: 15px 0;\n  grid-template-columns: repeat(6, auto);\n}\n.employer-long {\n  grid-column: 2 / span 3;\n}\n\n.grid.reference-verification-history {\n    grid-template-columns: repeat(7, auto);\n    white-space: pre-wrap;\n}\n\n.table-data.left {\n    text-align: left;\n  }\n  \n.table-data-rec-dec{\n    grid-column-start: 1;\n    grid-column-end: 6;\n}\n.super-strong {\n    font-size: 20pt;\n    font-weight: bolder;\n    text-align: center;\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.wrapit {\n    overflow-x: scroll;\n}\n\n.error-state {\n    background: #ce6161 !important;\n}\n\n.canceled-state {\n    background: #d88949 !important;\n}\n\n.voided-state {\n    background: #e2b94f !important;\n}\n\n.invoiced-state {\n    background: #A5DC89 !important;\n}\n\n.paid-state {\n    background: #6699CC !important;\n}\n\nh2.filter-title{\n    border-bottom: 1px solid #d8d9ea;\n    clear: both;\n}\n\n.change-property-decision-warn{\n    background-color: white;\n    border: 1px solid;\n    padding : 20px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 55;\n}\n\ndiv.modal-overlay-decision-warn{\n    background-color: rgba(0,0,0,.6);\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top:0;\n    left:0;\n    z-index: 50;\n}\n\n.decline-reason-control{\n    width: 100%;\n}\n\n.fa-trash,.fa-recycle{\n    color: #5484ff;\n    cursor: pointer;\n    margin: 1px;\n    display: inline;\n}\n\n#scrnNoteDisplay {\n    border: none !important;\n}\n\n\n.open-issue {\n    background-color: #ce6161 !important;\n    color: white !important;\n}\n\n.tnt-view {\n    background-color: rgb(177, 0, 0) !important;\n    color: white !important;\n}\n.ffd {\n    background-color: rgb(118, 0, 177) !important;\n    color: white !important;\n}\n\n.dispute-button {\n    background-color: #d88949 !important;\n}\n\n.release-report {\n    background-color: #54a54e !important;\n    color: white !important;\n}\n\n.disclose-report {\n    background-color: #0820a3 !important;\n    color: white !important;\n}\n.table-header-crim {\n    font-weight: 600 !important;\n    padding: 7px 5px;\n    color: #4b58a6;\n\n}\n\n.table-data-crim {\n    border-top: 1px solid #e7ebeb;\n    padding: 3px;\n    align-content: center;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    background: white;\n   \n}\n\n.criminal-history{\n    //display: grid;\n    //grid-auto-columns: auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    //border-bottom: 1px solid #d8d9ea;\n    //padding-top: 20px;\n}\n    \n    \n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
